import React, { Fragment } from "react";

export default (
  <>
    <path d="M8.8 4.6v3.3H6.4v4h2.4v12h5V12h3.3s.3-1.9.5-4.1h-3.8V5.1c0-.4.5-1 1.1-1h2.7V-.1h-3.7C8.7 0 8.8 4 8.8 4.6z" />
  </>
);
